import React from 'react';
import AppStoreBadges from './AppStoreBadges';
import './AppDownload.css';

export default function AppDownload() {
  return (
    <div className="card tp-app-download">
      <h3 className="title-m">Get the Faye app</h3>
      <p className="body-s tp-app-download__body">
        Your eSIM and lounge pass live in the Faye app — you'll need it to activate and use them. Scan a code or tap a badge to download.
      </p>
      <AppStoreBadges />
    </div>
  );
}
